import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum WorkflowTriggerName {
    STATE_REPEATED = 'state_repeated',
    STATE_TIMED_OUT = 'state_timed_out'
}

export class WorkflowTrigger {
    static readonly STATE_REPEATED = new WorkflowTrigger(
        WorkflowTriggerName.STATE_REPEATED,
        (
            <FormattedMessage
                id='WorkflowTrigger.state_repeated'
                description='The displayed value for the WorkflowTrigger state_repeated'
                defaultMessage='State repeated'
            />
        )
    );
    static readonly STATE_TIMED_OUT = new WorkflowTrigger(
        WorkflowTriggerName.STATE_TIMED_OUT,
        (
            <FormattedMessage
                id='WorkflowTrigger.state_timed_out'
                description='The displayed value for the WorkflowTrigger state_timed_out'
                defaultMessage='State timed out'
            />
        )
    );

    static readonly ALL = [WorkflowTrigger.STATE_REPEATED, WorkflowTrigger.STATE_TIMED_OUT];

    constructor(
        public readonly value: WorkflowTriggerName | string,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(trigger: string) {
        return this.ALL.find((t) => t.value == trigger);
    }
}

export interface TriggerSource {
    entity_type: string;
    entity_id: string;
}

export interface TriggerBody<T = string> {
    trigger: T;
    location?: string; //spot_id
    actor?: string; //user_id
    source?: TriggerSource | null;
    data?: any;
}

export interface PossibleTrigger<TTrigger = string, TState = string> {
    trigger: TTrigger;
    next_state: TState | null;
}
